import { createContext, useContext } from 'react';

import { noop } from 'lodash';

import { IScheduleAvailability } from 'modules/schedules/domain/entities';

export interface IDateAndTimeContext {
  day: IScheduleAvailability | null;
  time: string | null;

  setDay(day: IScheduleAvailability): void;
  setTime(time: string): void;
}

export const DateAndTimeContext = createContext({
  day: null,
  time: null,
  setDay: noop,
  setTime: noop,
} as IDateAndTimeContext);

export const useDateAndTime = () => {
  const context = useContext(DateAndTimeContext);

  return context;
};
